import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";

export const PageContainer = ({ children, sx, ...props }) => (
  <Box
    sx={{
      width: "100%",
      maxWidth: "96%",
      mx: "auto",
      boxSizing: "border-box",
      minWidth: 0,
      overflowX: "clip",
      ...sx,
    }}
    {...props}
  >
    {children}
  </Box>
);

PageContainer.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
